import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayers24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLayers24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m18.37 8.663-6.156-3.11a.5.5 0 0 0-.451 0l-6.156 3.11 6.156 3.109a.5.5 0 0 0 .45 0zm-5.48-4.448a2 2 0 0 0-1.803 0L4.047 7.77a1 1 0 0 0 0 1.785l7.04 3.556a2 2 0 0 0 1.803 0l7.04-3.556a1 1 0 0 0 0-1.785zm-9.81 7.373a.75.75 0 0 1 1.006-.335l7.903 3.951 7.903-3.951a.75.75 0 0 1 .67 1.342l-8.238 4.119-.335.168-.336-.168-8.238-4.12a.75.75 0 0 1-.336-1.006m1.006 2.926a.75.75 0 1 0-.671 1.342l8.238 4.119.335.167.336-.167 8.238-4.12a.75.75 0 1 0-.67-1.341l-7.903 3.951z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayers24);
